import { AddressField } from 'constants/loanApplication';
import { stateOptions } from 'constants/options';

export const mapReapiToAddressFields = suggestion => {
  const street = suggestion.unit
    ? `${suggestion.street || ''} ${suggestion.unit}`.trim()
    : suggestion.street;

  return {
    [AddressField.STREET]: street || null,
    [AddressField.CITY]: suggestion.city || null,
    [AddressField.ZIP]: suggestion.postcode || null,
    [AddressField.STATE]: stateOptions.find(({ value }) => value === suggestion.state) || null,
    [AddressField.COUNTY]: suggestion.county || null,
    [AddressField.LATITUDE]: suggestion.latitude ?? null,
    [AddressField.LONGITUDE]: suggestion.longitude ?? null,
    reapiPropertyId: suggestion.propertyId || null,
  };
};
